import Client from '@dealroadshow/socket-frontend-sdk';
import { injectable, inject } from 'inversify';
import { DataroomTenant } from '@dataroom/tenant/DataroomTenant';
import { DISocketTypes } from './DI/types';
import { ISocketClientFactory, type ISocketDispatcherFactoryMethod as ISocketDispatcherFactory } from './DI/interfaces';

@injectable()
class SocketClientFactory implements ISocketClientFactory {
  constructor(
    @inject(DISocketTypes.SocketDispatcher) private readonly socketDispatcherFactory: ISocketDispatcherFactory,
  ) {}

  create(tenantCode: DataroomTenant | null = null) {
    // @ts-ignore TODO: strictNullChecks — tenantCode is null but factory expects undefined
    return new Client(this.socketDispatcherFactory(tenantCode));
  }
}

export default SocketClientFactory;
